import { languageInfo } from '../languages';
import { batch } from '@preact/signals';
import { appendOutput, clearOutput, previewDoc, previewKind, previewScroll, previewSource, runLabel, runSequence, runStatus } from './output';
import { runPython, stopPython } from './python';
import { buildSandboxDocument } from './sandbox';

export function canRun(language: string): boolean {
  return languageInfo(language).runner !== null;
}

export function runLabelFor(language: string): string {
  const info = languageInfo(language);
  if (info.runner === 'html') return 'Preview';
  return 'Run';
}

/**
 * Run or preview the editor contents. Resolves when a Python run finishes; sandboxed runs resolve at once.
 * A `live` update re-renders a preview the user is watching, and keeps their place on the page.
 */
export async function runCode(language: string, code: string, { live = false }: { live?: boolean } = {}): Promise<void> {
  const info = languageInfo(language);
  if (!info.runner) return;
  clearOutput();
  previewSource.value = code;
  if (!live) previewScroll.value = null;
  if (!code.trim()) {
    appendOutput({ kind: 'info', text: 'The editor is empty.\n' });
    return;
  }
  if (info.runner === 'python') {
    previewDoc.value = null;
    previewKind.value = null;
    await runPython(code);
    return;
  }
  const runner = info.runner;
  batch(() => {
    previewKind.value = runner;
    previewDoc.value = buildSandboxDocument(runner, code, live ? previewScroll.peek() : null);
    runSequence.value += 1;
    runStatus.value = 'idle';
    runLabel.value = '';
  });
}

export function stopRun(): void {
  if (runStatus.value !== 'idle') stopPython();
}
